import { render, staticRenderFns } from "./AboutIdentity.vue?vue&type=template&id=0d6a9cc4"
import script from "./AboutIdentity.vue?vue&type=script&lang=js"
export * from "./AboutIdentity.vue?vue&type=script&lang=js"
import style0 from "./AboutIdentity.vue?vue&type=style&index=0&id=0d6a9cc4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports